export enum BookingDayStatus {
	Active = 1,
	Sickness = 2,
	NoShow = 3,
	ClientCancelled = 4,
	ActOfGod = 5,
	PersonalAppt = 6,
}
